import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultIcon", "objectTypeId", "objectId", "avatarSize"];
import PortalIdParser from 'PortalIdParser';
import { Avatar } from 'avatar-components/Avatar';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { specialtyColor } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmCitationIcon = _ref => {
  let {
      defaultIcon,
      objectTypeId,
      objectId,
      avatarSize = 'xxs'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const portalId = PortalIdParser.get();
  const isValidForAvatar = objectId && portalId && (objectTypeId === CONTACT_TYPE_ID || objectTypeId === COMPANY_TYPE_ID);
  if (isValidForAvatar) {
    return /*#__PURE__*/_jsx(Avatar, {
      marginBlockEnd: "0",
      size: avatarSize,
      type: "vid",
      lookup: {
        vid: Number(objectId)
      }
    });
  }
  return /*#__PURE__*/_jsx(IconCircle, Object.assign({
    backgroundColor: specialtyColor('breeze-icon-primary-default'),
    borderColor: specialtyColor('breeze-border-tertiary-default'),
    borderWidth: "100",
    borderStyle: "solid",
    color: specialtyColor('breeze-icon-icon-button-default')
  }, rest, {
    icon: defaultIcon
  }));
};
export default CrmCitationIcon;